import script from "./InPlaceTextEdit.vue?vue&type=script&lang=ts&setup=true"
export * from "./InPlaceTextEdit.vue?vue&type=script&lang=ts&setup=true"

import "./InPlaceTextEdit.vue?vue&type=style&index=0&id=79bebe88&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79bebe88"]])

export default __exports__